export default "__VITE_ASSET__CibMgZzg__"